import React from "react";
import * as XLSX from "xlsx";
import "./google_fonts.css";
import "./App.css";
import {
  Page,
  PDFViewer,
  Text,
  Image,
  View,
  Document,
  Font,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import QRCode from "qrcode";

import MyCustomFont from "./fonts/Helvetica-Bold.ttf";

const fontFamilyList = {
  "Helvetica Neue": MyCustomFont,
  // "Hind Vadodara": `//fonts.gstatic.com/s/hindvadodara/v2/9c6KKeibr6NtFqknnNxZB2bSELdkQ3Les1sVIQZgz9g.ttf`,
  // Abel: `//fonts.gstatic.com/s/abel/v6/N59kklKPso9WzbZH9jwJSg.ttf`,
  // Roboto: `//fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf`,
  // "Open Sans": `//fonts.gstatic.com/s/opensans/v13/cJZKeOuBrn4kERxqtaUH3aCWcynf_cDxXwCLxiixG1c.ttf`,
  // Acme: `//fonts.gstatic.com/s/acme/v5/h0STFiiHJJuefGZJAxrSiA.ttf`,
  // '':``,
  // '':``,
};

Font.register({
  family: "Helvetica Neue",
  src: "./fonts/Helvetica-Bold.ttf",
});

const isActiveMappingForm = false;

function App() {
  const [isPDFViewerActive, setIsPDFViewerActive] = React.useState(false);
  const [isTemplateEditable, setIsTemplateEditable] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [templateData, setTemplateData] = React.useState({
    "Issue Date": "",
    "Full Name of the Applicant\r\n(CAPITAL LETTER)": "Employee Name",
    "Employee ID Number (EID)": "Employee ID",
    "Date of Joining": "",
    'Designation': "Designation",
    'Department': "",
    'Department2': "",
    "Type of work": "",
    "Blood Group": "",
    "Village /Area ": "Address",
    "Police Station": "",
    "Post Office": "",
    "qrcode": "",
    District: "",
    District: "",
    "National ID Card Number (NID No.) ": "National ID Card",
  });
  const [sheetData, setSheetData] = React.useState(null);
  const [photoFolder, setPhotoFolder] = React.useState(null);
  const [signatureFolder, setSignatureFolder] = React.useState(null);
  const [qRCodesPhotoFolder, setQRCodesPhotoFolder] = React.useState(null);
  const [sheetColumn, setSheetColumn] = React.useState(null);
  const [activeFont, setActiveFont] = React.useState(`Helvetica Neue`);

  // const [dataColumn, setDataColumn] = React.useState({
  //   Name: "Name",
  //   Designation: "Designation",
  //   Department: "Department",
  //   EID: "EID",
  //   Blood: "Blood Group",
  //   IssueDate: "Issue Date",
  //   DOJ: "Date of Joining",
  //   TOW: "Type of work",
  //   Address: "Address",
  //   District: "District",
  //   PS: "Police Station",
  //   PO: "Post Office",
  //   PC: "Postal Code",
  //   NID: "NID",
  //   Photo: "Photo",
  //   Signature: "Signature",
  // });

  const [dataColumn, setDataColumn] = React.useState({
    Name: "Full Name of the Applicant\r\n(CAPITAL LETTER)",
    Designation: "Designation",
    Department: "Department line 1",
    Department2: "Department line 2",
    "ID No": "Employee ID Number (EID)",
    "Blood Group": "Blood Group",
    "Issue Date": "Issue Date \r\n\r\n(For HR Use Only) ",
    "Date of Joining": "Date of Joining",
    "Type of work": "Type of work",
    "Area/Village": "Village /Area ",
    "Police Station": "Police Station",
    "Post Office": "Post Office",
    "Postal Code": "Postal Code",
    qrcode: "qrcode",
    District: "District",
    NID: "National ID Card Number (NID No.) ",
  });

  //
  const [customStyles, setCustomStyles] = React.useState({
    page: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      display: "flex",
      backgroundColor: "#fff",
      fontFamily: activeFont,
      width: "638px",
      height: "1013px",
      overflow: "hidden",
      margin: 0,
      padding: 0,
    },
    wrapper: {
      marginBottom: "0px",
      display: "flex",
      flexDirection: "row",
    },
    section: {
      fontSize: 12,
      color: "#000",
      margin: 10,
      padding: 0,
      display: "block",
      position: "relative",
      width: "638px",
      height: "1013px",
      // border: "1px solid rgb(11, 50, 63)",
      overflow: "hidden",
      fontFamily: activeFont,
    },

    template: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "638px",
      height: "1013px",
      overflow: "hidden",
    },

    photo: {
      position: "absolute",
      objectFit: "contain",
      top: "180px",
      left: "171.5px",
      width: "296px",
      height: "296px",
      borderRadius: "50%",
      overflow: "hidden",
    },

    signatureimage: {
      position: "absolute",
      // objectFit: "cover",
      // objectFit: "contain",
      bottom: "9%",
      left: "6%",
      width: "35%",
      height: "5%",
      overflow: "hidden",
      // mixBlendMode: 'hard-light',
    },

    qrphoto: {
      overflow: "hidden",
      position: 'absolute',
      right: '240px',
      top: '140px',
      padding: '0',
      width: '170px',
      height: '170px'
    },

    namesection: {
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "center",
      display: "flex",
      // marginTop: '160px',
      position: "absolute",
      top: "155px",
      width: "100%",
      fontWeight: "bold",
      fontFamily: activeFont,
      lineHeight: "1.3",
      textAlign: "center",
      overflow: "hidden",
    },

    details: {
      flexFlow: "column wrap",
      justifyContent: "left",
      display: "flex",
      position: "absolute",
      top: "59%",
      left: "4%",
      width: "95%",
      fontFamily: activeFont,
      fontSize: "32px",
      fontWeight: "900",
      lineHeight: "1.3",
      textAlign: "left",
      letterSpacing: "0px",
    },

    details_value: {
      flexFlow: "column wrap",
      justifyContent: "left",
      display: "flex",
      position: "absolute",
      top: "59%",
      left: "41%",
      width: "55%",
      fontFamily: activeFont,
      fontSize: "32px",
      fontWeight: "900",
      lineHeight: "1.3",
      textAlign: "left",
      letterSpacing: "0px",
      overflow: 'hidden'
    },

    details_value_department: {
      fontFamily: activeFont,
      fontSize: "32px",
    },

    details_data: {
      display: "flex",
    },
    label: {
      display: "block",
      // width: "60px",
    },

    backsection: {
      fontSize: "22px",
      fontWeight: "900",
      lineHeight: "1.15",
      color: "#000000",
      position: "absolute",
      top: "31%",
      left: "2%",
      width: "96%",
      textAlign: "left",
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "center",
      display: "flex",
      overflow: "hidden",
      fontFamily: activeFont,
    },
    infosection: {
      fontSize: "22px",
      fontWeight: "900",
      lineHeight: "1.3",
      color: "#000000",
      position: "absolute",
      top: "60%",
      left: "2%",
      width: "96%",
      textAlign: "left",
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "center",
      display: "flex",
      overflow: "hidden",
      fontFamily: activeFont,
    },

    name: {
      color: "#17739d",
      fontSize: "42px",
      flexFlow: "column wrap",
      justifyContent: "center",
      display: "flex",
      position: "absolute",
      top: "49%",
      width: "100%",
      fontFamily: activeFont,
      lineHeight: "1.3",
      textAlign: "center",
      overflow: "hidden",
      textTransform: "uppercase",
      fontWeight: "900",
      letterSpacing: "0px",
    },

    designation: {
      fontSize: "36px",
      flexFlow: "column wrap",
      justifyContent: "center",
      display: "flex",
      position: "absolute",
      top: "54%",
      width: "100%",
      fontWeight: "900",
      fontFamily: activeFont,
      lineHeight: "1.3",
      textAlign: "center",
      overflow: "hidden",
      textTransform: "capitalize",
      letterSpacing: "0px",
    },

    eid: {
      fontSize: 12,
      color: "#000000",
      fontFamily: activeFont,
    },
    card_no: {
      fontSize: "26px",
      color: "#000000",
      position: "absolute",
      left: "-30px",
      top: "32%",
      fontWeight: "900",
      fontFamily: activeFont,
      transform: "rotate(-90deg)",
    },
  });
  const [activeTemplateTag, setActiveTemplateTag] = React.useState(null);

  // const [qrCodeImgUrl, setQrCodeImgUrl] = React.useState("");

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const workbook = XLSX.read(event.target.result, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetDataJSON = XLSX.utils.sheet_to_json(sheet);
      setSheetData(sheetDataJSON);
      qrCodeGenarator(sheetDataJSON);
      
      setSheetColumn(sheetDataJSON[0]);

      // console.log(sheetDataJSON)
    };

    reader.readAsBinaryString(file);
  };

  const qrCodeGenarator = async (dataItem) => {
    for (let key = 0; key < dataItem.length; key++) {
      const item = dataItem[key];
      const eid = item["Employee ID Number (EID)"] || "";
      const url = await QRCode.toDataURL(eid.toString());
      dataItem[key]["qrcode"] = url;
    }

    console.log("Final data with QR codes:", dataItem);
    setData(dataItem);
  };

  const download = (url, fileName = "id-card.pdf") => {
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadAllPdf = () => {
    let buttons = document.querySelectorAll(".download-btn-group");
    for (let i = 0; i < buttons.length; i++) {
      download(
        buttons[i].querySelector("a").getAttribute("href"),
        buttons[i].querySelector("a").getAttribute("download")
      );
    }
  };

  const updateStyle = (e) => {
    let val = e.target.value;
    let key = e.target.getAttribute("data-key");
    let pkey = e.target.getAttribute("data-pkey");
    let newStyle = { ...customStyles[pkey], [key]: val };
    let prevData = { ...customStyles, [pkey]: { ...newStyle } };
    setCustomStyles(prevData);
  };

  const updateFontSize = (key, value) => {
    let pkey = activeTemplateTag;
    let val = value + parseInt(customStyles[pkey][key]) + "px";
    let newStyle = { ...customStyles[pkey], [key]: val };
    let prevData = { ...customStyles, [pkey]: { ...newStyle } };
    setCustomStyles(prevData);
  };

  const updatePosition = (key, value) => {
    let pkey = activeTemplateTag;
    let val = value + parseInt(customStyles[pkey][key]) + "%";
    let newStyle = { ...customStyles[pkey], [key]: val };
    let prevData = { ...customStyles, [pkey]: { ...newStyle } };
    setCustomStyles(prevData);
  };

  const updateFontFamily = (fontFamilyName = "") => {
    let prevCss = { ...customStyles };
    Object.keys(prevCss).map((pkey) => {
      if (customStyles[pkey]?.fontFamily) {
        let newStyle = { ...customStyles[pkey], fontFamily: fontFamilyName };
        prevCss = { ...prevCss, [pkey]: { ...newStyle } };
      }

      return true;
    });
    setCustomStyles(prevCss);
  };

  const handlePhotoUpload = (e) => {
    if (e.target.files?.length) {
      let photos = e.target.files;
      let photoObj = {};
      Object.keys(photos).map((key) => {
        let photo = photos[key];
        photoObj[photo["name"].replace(/\.[^/.]+$/, "")] =
          URL.createObjectURL(photo);

        return true;
      });
      setPhotoFolder(photoObj);
    }
  };

  const handleRemoveBackground = async (image) => {
    const apiKey = "njv7RHG7MqkW3iqVX9wgPLxm";
    const apiUrl = "https://api.remove.bg/v1.0/removebg";

    const formData = new FormData();
    formData.append("image_file", image, image.name);
    formData.append("size", 'auto');

    try {
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'X-Api-Key': apiKey
        },
        body: formData
      });

      const data = await res.blob();
      const imageUrl = URL.createObjectURL(data);

      return imageUrl;
      // setBgRemove(imageUrl);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSignatureUpload = (e) => {
    if (e.target.files?.length) {
      let photos = e.target.files;
      let photoObj = {};
      Object.keys(photos).map((key) => {
        let photo = photos[key];

        photoObj[photo["name"].replace(/\.[^/.]+$/, "")] = URL.createObjectURL(photo);

        return true;
      });
      setSignatureFolder(photoObj);
    }
  };


  return (
    <div className="App">
      <div className="header">
        <img src={"./logo.svg"} alt="SEBPO Logo" />
      </div>


      <div className="container">
        <div className="id-form">
          <fieldset>
            <legend>SEBPO Rapid ID Card Generator (RIG)</legend>

            <a
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                cursor: 'pointer',
                color: 'rgb(6, 111, 152)',
                marginRight: '15px',
                textDecoration: 'none'
              }}
              href="./ID-Card-Sample.zip"

            // onClick={() => {
            //   download("./ID-Card-Sample.zip", "ID-Card-Sample.zip");
            // }}
            >
              Download Sample Data
            </a>

            <div className="id-form--file">
              <div>
                <label>Upload Excel Sheet</label>
                <input type="file" onChange={handleFileUpload} />

              </div>

              <div>
                <label>Upload Photo</label>
                <input
                  type="file"
                  name="files[]"
                  id="files"
                  accept="image/png, image/jpg, image/jpeg"
                  multiple
                  directory=""
                  webkitdirectory=""
                  mozdirectory=""
                  onChange={handlePhotoUpload}
                />
              </div>

              <div>
                <label>Upload Signature Photo</label>
                <input
                  type="file"
                  name="files[]"
                  id="files"
                  multiple
                  accept="image/png"
                  directory=""
                  webkitdirectory=""
                  mozdirectory=""
                  onChange={handleSignatureUpload}
                />
              </div>


            </div>

            {/* dataColumn */}
            {isTemplateEditable && isActiveMappingForm && (
              <>
                <div>
                  <label>Font Family:</label>
                  <select
                    defaultValue={activeFont}
                    onChange={(e) => {
                      let dataValue = e.target.value || "";
                      setActiveFont(dataValue);
                      updateFontFamily(dataValue);

                      Font.register({
                        family: dataValue,
                        format: "truetype",
                        fontWeight: "900",
                        src: fontFamilyList[dataValue],
                      });
                    }}
                  >
                    {fontFamilyList &&
                      Object.keys(fontFamilyList).map((scKey) => {
                        return (
                          <option key={scKey} value={scKey}>
                            {scKey}
                          </option>
                        );
                      })}
                  </select>
                </div>

                <div className="select-group">
                  {isActiveMappingForm &&
                    dataColumn &&
                    sheetColumn &&
                    Object.keys(dataColumn).map((key) => {
                      return (
                        <div key={`select-group-${key}`}>
                          <label>{key}</label>
                          <select
                            data-key={key}
                            onChange={(e) => {
                              let dataValue = e.target.value || "";
                              let dataKey = e.target.getAttribute("data-key") || "";

                              if (dataKey && dataValue) {
                                let prevDataColumn = dataColumn;
                                prevDataColumn[dataKey] = dataValue;
                                setDataColumn(prevDataColumn);
                              }
                            }}
                          >
                            <option value={""}></option>
                            {sheetColumn &&
                              Object.keys(sheetColumn).map((scKey) => {
                                return (
                                  <option key={scKey} value={scKey}>
                                    {scKey}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      );
                    })}


                </div>

              </>
            )}

            {/* {dataColumn && sheetColumn && ( */}
            <>
              <button
                type="button"
                onClick={() => {
                  setIsPDFViewerActive(!isPDFViewerActive);
                }}
              >
                {isPDFViewerActive ? "Hide PDF View" : "Generate PDF "}
              </button>

              {isPDFViewerActive && (
                <button
                  type="button"
                  onClick={() => {
                    downloadAllPdf();
                  }}
                >
                  Download All PDF
                </button>
              )}
            </>
            {/* )} */}

            <div className="font-editor">
              <label>Font Size: </label>
              <button
                type="button"
                onClick={() => updateFontSize("fontSize", 1)}
              >
                +
              </button>
              <button
                type="button"
                onClick={() => updateFontSize("fontSize", -1)}
              >
                -
              </button>
            </div>

            {isTemplateEditable && activeTemplateTag && (
              <div className="template-editor">
                <fieldset>
                  <legend>{activeTemplateTag.replace(/_/g, " ")}</legend>

                  <div>
                    <button
                      type="button"
                      onClick={() => updateFontSize("fontWeight", 700)}
                    >
                      B
                    </button>
                    <button
                      type="button"
                      onClick={() => updateFontSize("fontSize", 1)}
                    >
                      +
                    </button>
                    <button
                      type="button"
                      onClick={() => updateFontSize("fontSize", -1)}
                    >
                      -
                    </button>
                    <button
                      type="button"
                      onClick={() => updatePosition("left", 1)}
                    >
                      right
                    </button>
                    <button
                      type="button"
                      onClick={() => updatePosition("left", -1)}
                    >
                      left
                    </button>
                    <button
                      type="button"
                      onClick={() => updatePosition("top", 1)}
                    >
                      top
                    </button>
                    <button
                      type="button"
                      onClick={() => updatePosition("top", -1)}
                    >
                      bottom
                    </button>
                  </div>

                  {/* {activeTemplateTag &&
                  Object.keys(customStyles[activeTemplateTag]).map((key) => {
                    return (
                      <>
                        <div>
                          <input type="text"  value={key} />
                          <input
                            type="text"
                            data-pkey={activeTemplateTag}
                            data-key={key}
                            onChange={updateStyle}
                            value={customStyles[activeTemplateTag][key]}
                          />
                        </div>
                      </>
                    );
                  })} */}
                </fieldset>
              </div>
            )}

            <div className="guideline">
              <h3>Please follow these guidelines:</h3>
              <ol>
                <li>Ensure all columns in the Excel sheet are formatted as text, including dates.</li>
                <li>Photo image size should be 1000px by 1000px, or maintain an aspect ratio of 1:1 (square).</li>
                <li>To avoid cropping the head in photos, please ensure a 30px to 50px padding from the top.</li>
                <li>Signature image size should be 530px by 150px.</li>
                <li>Please upload photos and signatures as PNG/JPG images with either a transparent background or a solid white&nbsp;background.</li>
                <li>If you need to edit the photo and signature image in Photoshop,
                  <a
                    style={{
                      cursor: 'pointer',
                      color: 'rgb(6, 111, 152)',
                      textDecoration: 'none'
                    }}
                    href="./photo-and-signature-image-template.psd"
                  > this template
                  </a> will help you follow the guidelines.</li>
              </ol>

            </div>
          </fieldset>
        </div>

        <div className="id-preview">
          <fieldset>
            <legend>ID Card Preivew</legend>
            {!data && templateData && (
              <>
                <MyTemplate
                  data={templateData}
                  dataColumn={dataColumn}
                  isPDFViewerActive={isPDFViewerActive}
                  photoFolder={photoFolder}
                  signatureFolder={signatureFolder}
                  styles={customStyles}
                  activeTemplateTag={activeTemplateTag}
                  setActiveTemplateTag={setActiveTemplateTag}
                />
              </>
            )}

            {data && (
              <>
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                <MyDocument
                  key="mydocument-test"
                  infodata={data}
                  dataColumn={dataColumn}
                  isPDFViewerActive={isPDFViewerActive}
                  photoFolder={photoFolder}
                  signatureFolder={signatureFolder}
                  height={"900px"}
                  width={"1200px"}
                  styles={customStyles}
                  activeTemplateTag={activeTemplateTag}
                  setActiveTemplateTag={setActiveTemplateTag}
                />
              </>
            )}
          </fieldset>
        </div>
      </div>

      <div className="footer"><div className="ms-auto"><span className="me-1">SEBPO Creative App: Powered by <a href="https://sebpo.com/" target="_blank" className="text-dark text-decoration-none" rel="noopener noreferrer">SEBPO</a> Creative Team</span></div></div>
    </div>
  );
}

// const styles = StyleSheet.create(customStyles);

// Create Document Component
const MyDocument = ({
  infodata,
  dataColumn,
  isPDFViewerActive,
  photoFolder,
  signatureFolder,
  styles,
  activeTemplateTag,
  setActiveTemplateTag,
}) => {
  return (
    <div key={"document"}>
      {infodata.map((data, key) => {
        return (
          <>
            {!isPDFViewerActive && (
              <MyTemplate
                key={"template-" + key}
                data={data}
                dataColumn={dataColumn}
                isPDFViewerActive={isPDFViewerActive}
                photoFolder={photoFolder}
                signatureFolder={signatureFolder}
                styles={styles}
                activeTemplateTag={activeTemplateTag}
                setActiveTemplateTag={setActiveTemplateTag}
              />
            )}

            {isPDFViewerActive && (
              <>
                {key === 0 && (
                  <PDFViewer height={"550px"} width={"900px"}>
                    <MyCard
                      key={"mycard-" + key}
                      data={data}
                      dataColumn={dataColumn}
                      isPDFViewerActive={isPDFViewerActive}
                      photoFolder={photoFolder}
                      signatureFolder={signatureFolder}
                      styles={styles}
                    />
                  </PDFViewer>
                )}

                {/* {key !== 0 && ( */}
                <div className="download-btn-group">
                  <PDFDownloadLink
                    document={
                      <MyCard
                        data={data}
                        dataColumn={dataColumn}
                        isPDFViewerActive={isPDFViewerActive}
                        photoFolder={photoFolder}
                        signatureFolder={signatureFolder}
                        styles={styles}
                      />
                    }
                    fileName={`${data[dataColumn["ID No"]]}.pdf`}
                  >
                    {({ blob, url, loading, error }) => {
                      return loading
                        ? "Loading document..."
                        : `Download ${data[dataColumn["ID No"]]}`;
                    }}
                  </PDFDownloadLink>
                </div>
                {/* )} */}
              </>
            )}
          </>
        );
      })}
    </div>
  );
};

// Create Document Component
const MyCard = ({
  data,
  dataColumn,
  isPDFViewerActive,
  photoFolder,
  signatureFolder,
  styles,
}) => {
  // let imageUrl = "https://creativeapp.sebpo.net/" + data["Image URL"];
  // let imageUrl = "./" + data["Image URL"];
  // let imageUrl = photoFolder[data[dataColumn["ID No"]]];
  // let signatureImageUrl = signatureFolder[data[dataColumn["ID No"]]];
  let imageUrl = photoFolder
    ? photoFolder[data[dataColumn["ID No"]]]
    : "./photo.jpg";
  let signatureImageUrl = signatureFolder
    ? signatureFolder[data[dataColumn["ID No"]]]
    : "./sign.png";

  let frontTemplateUrl = "./front.png";
  let backTemplateUrl = "./back.png";
  let key = data[dataColumn["ID No"]];

  return (
    <>
      <Document title="ID Card" >
        {/* front template start */}
        <Page
          size={{
            width: "638px",
            height: "1013px",
          }}
          style={styles.wrapper}
        >
          <View key={"front-" + key} style={styles.section}>
            {!isPDFViewerActive && (
              <>
                <img
                  style={styles.template}
                  src={frontTemplateUrl}
                  alt="front template"
                />
                <img style={styles.photo} src={imageUrl} alt="Photo" />
                <img
                  style={styles.signatureimage}
                  src={signatureImageUrl}
                  alt="signatureimage"
                />
              </>
            )}
            {isPDFViewerActive && (
              <>
                <Image
                  style={styles.template}
                  src={{ uri: frontTemplateUrl }}
                  alt="front template"
                />
                <Image
                  style={styles.photo}
                  src={{ uri: imageUrl }}
                  alt="Photo"
                />

                <Image
                  style={styles.signatureimage}
                  src={{ uri: signatureImageUrl }}
                  alt=""
                />
              </>
            )}

            <Text style={styles.name}>{data[dataColumn["Name"]]}</Text>
            <Text style={styles.designation}>{data["Designation"]}</Text>

            <View style={styles.details}>
              <Text style={styles.details_data}>
                <Text style={styles.label}>ID No</Text>
              </Text>
              <Text style={styles.details_data}>
                <Text style={styles.label}>Issue Date</Text>
              </Text>
              <Text style={styles.details_data}>
                <Text style={styles.label}>Date of Joining</Text>
              </Text>
              <Text style={styles.details_data}>
                <Text style={styles.label}>Type of work</Text>
              </Text>
              <Text style={styles.details_data}>
                <Text style={styles.label}>Department</Text>
              </Text>
            </View>
            <View style={styles.details_value}>
              <Text style={styles.details_data}>
                :&nbsp;{data[dataColumn["ID No"]]}
              </Text>
              <Text style={styles.details_data}>
                :&nbsp;{data[dataColumn["Issue Date"]]}
              </Text>
              <Text style={styles.details_data}>
                :&nbsp;{data[dataColumn["Date of Joining"]]}
              </Text>
              <Text style={styles.details_data}>
                :&nbsp;{data[dataColumn["Type of work"]]}
              </Text>
              <Text style={styles.details_data}>
                :&nbsp;
                <Text style={styles.details_value_department}>{data[dataColumn["Department"]]}</Text>
              </Text>
              <Text style={{ ...styles.details_data, paddingLeft: '20px' }}>
                <Text style={styles.details_value_department}>{data[dataColumn["Department2"]]}</Text>
              </Text>
            </View>
            <View style={styles.card_no}>
              <Text>Card No : {data[dataColumn["ID No"]]}</Text>
            </View>
          </View>
          {/* front template end */}
        </Page>
        <Page
          size={{
            width: "638px",
            height: "1013px",
          }}
          style={styles.wrapper}
        >
          {/* back template start */}
          <View key={"back-" + key} style={styles.section}>
            {!isPDFViewerActive && (
              <>
                <img
                  style={styles.template}
                  src={backTemplateUrl}
                  alt="Back Template"
                />
              </>
            )}

            {isPDFViewerActive && (
              <>
                <Image
                  style={styles.template}
                  src={{ uri: backTemplateUrl }}
                  alt="Back Template"
                />
                <Image
                  style={styles.qrphoto}
                  src={{ uri: data[dataColumn["qrcode"]] }}
                  // src={data[dataColumn["qrcode"]]}
                  alt="QR Photo"
                />
              </>
            )}

            <View style={styles.backsection}>
              <Text style={{ letterSpacing: '-1px' }}>
                Incase of lost, please report/return to SEBPO authority
              </Text>
              <Text>&nbsp;</Text>
              <Text>Office Address:</Text>
              <Text>Monem Business District - Kawran Bazar</Text>
              <Text>Abbas Garden Road - Mohakhali</Text>
              <Text style={{ marginBottom: '10px' }}>RAOWA Complex - Mohakhali</Text>
              <Text style={{ marginBottom: '10px' }}>Website: www.sebpo.com</Text>
              <Text>Company/Business Type:</Text>
              <Text>IT, ITES, and Telecommunication</Text>
            </View>

            <View style={styles.infosection}>
              <Text>Permanent Address:</Text>
              <Text>Area/Village: {data[dataColumn["Area/Village"]]}</Text>
              <Text>Police Station: {data[dataColumn["Police Station"]]}</Text>
              <Text>Post Office: {data[dataColumn["Post Office"]]}</Text>
              <Text>Postal Code: {data[dataColumn["Postal Code"]]}</Text>
              <Text style={{ marginBottom: '10px' }}>District: {data[dataColumn["District"]]}</Text>
              <Text>Blood Group: {data[dataColumn["Blood Group"]]}</Text>
              <Text style={{ marginBottom: '10px' }}>NID: {data[dataColumn["NID"]]}</Text>

              <Text data-tag="Text" >Shift Timings:</Text>
              <Text data-tag="Text" style={{ letterSpacing: '-1px', marginBottom: '10px' }}>07:00 AM - 04:00 PM | 01:00 PM - 10:00 PM | 10:00 PM - 07:00 AM</Text>
              <Text>Emergency Contact No.:</Text>
              <Text>09606221100, 09606221176, 09606221904</Text>

              {/* <Text>Joining Date: {data["Joining Date"]}</Text> */}
            </View>
          </View>
          {/* </View> */}
          {/* })} */}
        </Page>
      </Document>
    </>
  );
};

const MyTemplate = ({
  data,
  dataColumn,
  isPDFViewerActive,
  photoFolder,
  signatureFolder,
  styles,
  activeTemplateTag,
  setActiveTemplateTag,
}) => {
  // let imageUrl = "https://creativeapp.sebpo.net/" + data["Image URL"];
  // let imageUrl = "./" + data["Image URL"];
  let imageUrl = photoFolder
    ? photoFolder[data[dataColumn["ID No"]]]
    : "./photo.jpg";
  let signatureImageUrl = signatureFolder
    ? signatureFolder[data[dataColumn["ID No"]]]
    : "./sign.png";
  // let imageUrl = "./photo.jpg";
  // let signatureImageUrl = "./sign.png";
  let frontTemplateUrl = "./front.png";
  let backTemplateUrl = "./back.png";
  let key = data[dataColumn["ID No"]];
  // let name = data[dataColumn["Name"]];


  console.log(data)
  console.log(dataColumn)

  return (
    <>
      <div
        className="MyTemplate"
        data-tag="Document"
        title={data[dataColumn["ID No"]]}
        id={data[dataColumn["ID No"]]}
      >
        {/* front page template start */}
        <div className="MyTemplatePage" data-tag="Page" style={styles.wrapper}>
          <div data-tag="View" key={"front-" + key} style={styles.section}>
            <img
              style={styles.template}
              src={frontTemplateUrl}
              alt="front template"
            />
            {/* <img
              style={{ ...styles.template, opacity: "0.5" }}
              src={"./frontpage.png"}
              alt="front template"
            /> */}
            <img style={styles.photo} src={imageUrl} alt="Photo" />
            <img
              style={styles.signatureimage}
              src={signatureImageUrl}
              alt="signatureimage"
            />

            <div
              data-tag="Text"
              className={activeTemplateTag === "name" ? "active-template" : ""}
              onClick={() => setActiveTemplateTag("name")}
              style={styles.name}
            >
              {data[dataColumn["Name"]]}
            </div>
            <div
              data-tag="Text"
              style={styles.designation}
              className={
                activeTemplateTag === "designation" ? "active-template" : ""
              }
              onClick={() => setActiveTemplateTag("designation")}
            >
              {data["Designation"]}
            </div>

            <div
              data-tag="View"
              style={styles.details}
              className={
                activeTemplateTag === "details" ? "active-template" : ""
              }
              onClick={() => setActiveTemplateTag("details")}
            >
              <div
                data-tag="Text"
                style={styles.details_data}
                onClick={() => setActiveTemplateTag("details_data")}
              >
                <div data-tag="Text" style={styles.label}>
                  ID No
                </div>
              </div>
              <div data-tag="Text" style={styles.details_data}>
                <div data-tag="Text" style={styles.label}>
                  Issue Date
                </div>
              </div>

              <div data-tag="Text" style={styles.details_data}>
                <div data-tag="Text" style={styles.label}>
                  Date of Joining
                </div>
              </div>
              <div data-tag="Text" style={styles.details_data}>
                <div data-tag="Text" style={styles.label}>
                  Type of work
                </div>
              </div>
              <div data-tag="Text" style={styles.details_data}>
                <div data-tag="Text" style={styles.label}>
                  Department
                </div>
              </div>
            </div>
            <div
              data-tag="View"
              className={
                activeTemplateTag === "details_value" ? "active-template" : ""
              }
              // onClick={() => setActiveTemplateTag("details_value")}
              style={styles.details_value}
            >
              <div data-tag="Text" style={styles.details_data}>
                : &nbsp;{data[dataColumn["ID No"]]}
              </div>
              <div data-tag="Text" style={styles.details_data}>
                : &nbsp;{data[dataColumn["Issue Date"]]}
              </div>

              <div data-tag="Text" style={styles.details_data}>
                : &nbsp;{data[dataColumn["Date of Joining"]]}
              </div>
              <div data-tag="Text" style={styles.details_data}>
                : &nbsp;{data[dataColumn["Type of work"]]}
              </div>
              <div data-tag="Text">
                : &nbsp;
                <span
                  data-tag="Text"
                  className={
                    activeTemplateTag === "details_value_department" ? "active-template" : ""
                  }
                  style={styles.details_value_department}
                  onClick={() => setActiveTemplateTag("details_value_department")}
                >
                  {data[dataColumn["Department"]]}

                </span>
              </div>
              <div data-tag="Text" style={{ ...styles.details_data, paddingLeft: '25px' }} >
                <span
                  data-tag="Text"
                  className={
                    activeTemplateTag === "details_value_department" ? "active-template" : ""
                  }
                  style={styles.details_value_department}
                  onClick={() => setActiveTemplateTag("details_value_department")}
                >
                  {data[dataColumn["Department2"]]}

                </span>
              </div>
            </div>
            <div data-tag="View" style={styles.card_no}>
              <div data-tag="Text">Card No : {data[dataColumn["ID No"]]}</div>
            </div>
          </div>
          {/* front template end */}
        </div>

        {/* back page template start */}
        <div className="MyTemplatePage" data-tag="Page" style={styles.wrapper}>
          {/* back template start */}

          <div data-tag="View" key={"back-" + key} style={styles.section}>
            {!isPDFViewerActive && (
              <>
                <img
                  style={styles.template}
                  src={backTemplateUrl}
                  alt="Back Template"
                />
              </>
            )}

            {!isPDFViewerActive && data[dataColumn["qrcode"]] && (
              <>
                <img
                  className="qr-code"
                  src={data[dataColumn["qrcode"]]}
                  alt="Back Template"
                />
              </>
            )}

            <div
              data-tag="View"
              className={
                activeTemplateTag === "backsection" ? "active-template" : ""
              }
              onClick={() => setActiveTemplateTag("backsection")}
              style={styles.backsection}
            >
              <div data-tag="Text" style={{ letterSpacing: '-1px' }}>
                Incase of lost, please report/return to SEBPO authority
              </div>
              <div data-tag="Text">&nbsp;</div>
              <div data-tag="Text">Office Address:</div>
              <div data-tag="Text">Monem Business District - Kawran Bazar</div>
              <div data-tag="Text">Abbas Garden Road - Mohakhali</div>
              <div data-tag="Text" style={{ marginBottom: '10px' }}>RAOWA Complex - Mohakhali</div>
              <div data-tag="Text" style={{ marginBottom: '10px' }}>Website: www.sebpo.com</div>

              <div data-tag="Text">Company/Business Type:</div>
              <div data-tag="Text">IT, ITES, and Telecommunication</div>
            </div>

            <div
              data-tag="View"
              className={
                activeTemplateTag === "infosection" ? "active-template" : ""
              }
              onClick={() => setActiveTemplateTag("infosection")}
              style={styles.infosection}
            >
              <div data-tag="Text">Permanent Address:</div>               
              <div data-tag="Text">
                Area/Village: {data[dataColumn["Area/Village"]]}
              </div>
              <div data-tag="Text">
                Police Station: {data[dataColumn["Police Station"]]}
              </div>
              <div data-tag="Text">
                Post Office: {data[dataColumn["Post Office"]]}
              </div>
              <div data-tag="Text">
                Postal Code: {data[dataColumn["Postal Code"]]}
              </div>
              <div data-tag="Text" style={{ marginBottom: '10px' }}>
                District: {data[dataColumn["District"]]}
              </div>

              <div data-tag="Text">
                Blood Group: {data[dataColumn["Blood Group"]]}
              </div>
              <div data-tag="Text" style={{ marginBottom: '10px' }}>NID: {data[dataColumn["NID"]]}</div>
              <div data-tag="Text" >Shift Timings:</div>
              <div data-tag="Text" style={{ letterSpacing: '-1px', marginBottom: '10px' }}>07:00 AM - 04:00 PM | 01:00 PM - 10:00 PM | 10:00 PM - 07:00 AM</div>
              <div data-tag="Text">Emergency Contact No.:</div>
              <div data-tag="Text">09606221100, 09606221176, 09606221904</div>

              {/* <Text>Joining Date: {data["Joining Date"]}</Text> */}
            </div>
          </div>
          {/* </View> */}
          {/* })} */}
        </div>
      </div>
    </>
  );
};

export default App;
